import { render, staticRenderFns } from "./ConfirmarInstituicao.vue?vue&type=template&id=00a81ca0&"
import script from "./ConfirmarInstituicao.vue?vue&type=script&lang=js&"
export * from "./ConfirmarInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports